export const blueDkt = '#0082c3'
